// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/menu.js'; // eslint-disable-line

// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
// import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
// import ScrollOut from 'scroll-out';
/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

const setHeaderHeight = () => {
  const header = document.querySelector('.header');

  if (header) {
    document.body.style.setProperty(
      '--header-height',
      `${header.offsetHeight}px`
    );
  }
};

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  /**
   * Accordion
   */
  $('.accordion__title').each(function () {
    // Initialize aria-expanded based on active class
    const $this = $(this);
    const $accordionItem = $this.closest('.accordion__item');
    const expanded = $accordionItem.hasClass('active') ? 'true' : 'false';
    $this.attr('aria-expanded', expanded);
  });

  $('.accordion__title').on('click', function () {
    const $this = $(this);
    const $accordionItem = $this.closest('.accordion__item');
    const $accordionContent = $accordionItem.find('.accordion__content');

    if ($accordionItem.hasClass('active')) {
      $accordionContent.slideUp(300, function () {
        $accordionItem.removeClass('active');
        $this.attr('aria-expanded', 'false');
      });
    } else {
      // Close other open accordion items
      $this
        .closest('.accordion')
        .find('.accordion__item.active .accordion__content')
        .slideUp(300, function () {
          const $parentItem = $(this).closest('.accordion__item');
          $parentItem.removeClass('active');
          $parentItem.find('.accordion__title').attr('aria-expanded', 'false');
        });

      // Open the clicked accordion item
      $accordionContent.slideDown(300, function () {
        $accordionItem.addClass('active');
        $this.attr('aria-expanded', 'true');
      });
    }
  });

  // Allow Enter and Space to toggle the accordion when the title (button) is focused

  $(document).on('keydown', '.accordion__title', function (e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      $(this).trigger('click');
    }
  });

  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  // ScrollOut({
  //   threshold: 0.5,
  //   once: true,
  //   onShown: function (element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function (i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function () {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  resizeVideo();

  /**
   * Hero video modal
   */
  const $heroModal = $('#hero-video-modal');

  if ($heroModal.length) {
    const $heroModalTrigger = $('.hero-modal');
    const $heroModalClose = $heroModal.find('.hero__modal-close');
    const $heroModalIframe = $heroModal.find('iframe');
    const heroVideoSrc = $heroModalIframe.attr('src');
    let $previouslyFocusedElement;

    const getHeroVideoSrc = () => {
      if (!heroVideoSrc) {
        return '';
      }

      try {
        const videoUrl = new URL(heroVideoSrc, window.location.href);
        const isVimeoEmbed = /(^|\.)player\.vimeo\.com$/.test(
          videoUrl.hostname
        );

        if (isVimeoEmbed) {
          const playerOptions = {
            airplay: '0',
            ask_ai: '0',
            audio_track: '0',
            autoplay: '1',
            badge: '0',
            byline: '0',
            cc: '0',
            chapters: '0',
            chromecast: '0',
            controls: '1',
            fullscreen: '0',
            interactive_markers: '0',
            muted: '0',
            pip: '0',
            playsinline: '1',
            portrait: '0',
            progress_bar: '0',
            quality_selector: '0',
            speed: '0',
            title: '0',
            transcript: '0',
            unmute_button: '1',
            vimeo_logo: '0',
            volume: '1',
            watch_full_video: '0',
          };

          Object.entries(playerOptions).forEach(([option, value]) => {
            videoUrl.searchParams.set(option, value);
          });
        }

        return videoUrl.toString();
      } catch (error) {
        return heroVideoSrc;
      }
    };

    if ($heroModalIframe.length) {
      const iframePermissions = ($heroModalIframe.attr('allow') || '')
        .split(';')
        .map((permission) => permission.trim())
        .filter(Boolean);

      if (!iframePermissions.includes('autoplay')) {
        iframePermissions.push('autoplay');
      }

      $heroModalIframe
        .attr('allow', iframePermissions.join('; '))
        .removeAttr('src');
    }

    const closeHeroModal = () => {
      $heroModal.prop('hidden', true).attr('aria-hidden', 'true');
      $heroModalTrigger.attr('aria-expanded', 'false');
      $('body').removeClass('body-fixed video-modal-open');

      // Unload the player so playback stops completely while the modal is closed.
      if ($heroModalIframe.length) {
        $heroModalIframe.removeAttr('src');
      }

      if ($previouslyFocusedElement) {
        $previouslyFocusedElement.trigger('focus');
      }
    };

    $heroModalTrigger.on('click', function () {
      $previouslyFocusedElement = $(this);
      $heroModal.prop('hidden', false).attr('aria-hidden', 'false');
      $(this).attr('aria-expanded', 'true');
      $('body').addClass('body-fixed video-modal-open');

      if ($heroModalIframe.length) {
        $heroModalIframe.attr('src', getHeroVideoSrc());
      }

      $heroModalClose.trigger('focus');
    });

    $heroModalClose.on('click', closeHeroModal);

    $heroModal.on('click', function (event) {
      if (event.target === this) {
        closeHeroModal();
      }
    });

    $(document).on('keydown', function (event) {
      if (event.key === 'Escape' && !$heroModal.prop('hidden')) {
        closeHeroModal();
      }
    });
  }
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }

  /**
   * Create CSS variable for header height
   */
  setHeaderHeight();
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here
  resizeVideo();

  /**
   * Create CSS variable for header height
   */
  setHeaderHeight();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
});

document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.submenu-toggle');

  function updateParentsHeight(el) {
    let parentSubmenu = el.closest('.menu.submenu');

    while (parentSubmenu) {
      parentSubmenu.style.maxHeight = parentSubmenu.scrollHeight + 'px';
      parentSubmenu = parentSubmenu.parentElement.closest('.menu.submenu');
    }
  }

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();

      const parent = this.closest('.has-dropdown');
      const submenu = parent.querySelector(':scope > .menu.submenu');
      const expanded = this.getAttribute('aria-expanded') === 'true';

      this.setAttribute('aria-expanded', !expanded);
      parent.classList.toggle('submenu-open');

      if (submenu) {
        if (expanded) {
          submenu.style.maxHeight = null;
        } else {
          submenu.style.maxHeight = submenu.scrollHeight + 'px';
          updateParentsHeight(submenu);
        }
      }
    });
  });
});
